import { NotFound } from "http-errors";
import React from "react";

/**
 * props:
 *  - Function chooseSuggestedEmail select the suggested email that has been clicked.
 *  - Boolean foundAuthor is the user already an author on this Syllabus?
 **/
const AddTeamMember = (props) => {
  const key = "addauth";
  //BUTTON TO SHOW 'ADD USER' FORM
  const btn = (
    <button className="btn btn-primary" onClick={(e) => props.focus(key, e)}>
      Add Team Member
    </button>
  );
  //ADD USER BUTTON
  const submit = (
    <button
      className="btn btn-primary"
      onClick={(e) => props.submit(props.userId, e)}
    >
      Add
    </button>
  );
  //SUGGESTED USER
  const suggested = props.suggestedEmails.map((email, ix) => {
    return (
      <button
        key={"suggestion-" + ix}
        className="list-group-item list-group-item-action"
        onClick={(e) => props.chooseSuggestedEmail(email, e)}
      >
        {email}
      </button>
    );
  });
  //NOT VALID OPTION MESSAGE
  const notfound = props.foundAuthor ? (
    <div>&#9989; Already an author.</div>
  ) : (
    <div>Not a valid option...</div>
  );
  //INPUT FORM
  const input = (
    <div className="col-5 d-flex flex-row">
      <div className="d-flex flex-column">
        <input
          id={key + "input"}
          autoComplete="off"
          className="col-9 inline"
          style={{ height: "3rem" }}
          type="text"
          value={props.search}
          placeholder="Search users by email"
          onChange={(e) => props.handleChange({}, e)}
        />
        {props.suggestedEmails.length > 0 ? (
          <div className="list-group">{suggested}</div>
        ) : (
          ""
        )}
      </div>
      <div className="d-flex flex-column">
        {props.userId ? submit : notfound}
      </div>
    </div>
  );

  return (
    <div id={key} onClick={(e) => props.focus(key, e)}>
      {props.focusKey == key ? input : btn}
    </div>
  );
};

export default AddTeamMember;
